import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { DetalleVistaDinamica } from '@app/shared';
import { VistaSolicitudesVital } from '@app/shared/models/solicitudes-vital.model';

@Injectable()
export class HomeDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta las pestañas asignadas al grupo del usuario en sesion
   *
   * @returns {Observable<any[]>}
   * @memberof HomeDataService
   */
  getDynamicView(): Observable<DetalleVistaDinamica[]> {
    return new Observable(obs => {
      this.http.get<DetalleVistaDinamica[]>(this.api.get('dynamicViewDetail')).subscribe(
        masterTables => {
          obs.next(masterTables);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  
  /**
   * Consulta las pestaña de solicitudes de vital
   *
   * @returns {Observable<any[]>}
   * @memberof HomeDataService
   */
  getVitalView(): Observable<VistaSolicitudesVital> {
    return new Observable(obs => {
      this.http.get<VistaSolicitudesVital>(this.api.get('ViewVital')).subscribe(
        Table => {
          obs.next(Table);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/home/shared/home.data.service.ts